// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Ibrw","signatureBlock":"Footer_signatureBlock__3msZc","signature":"Footer_signature__3Cb_N"};